import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";

const ConnectionStatusModal = () => {
  const [isConnected, setIsConnected] = useState(navigator.onLine);
  const [isVisible, setIsVisible] = useState(false);
  const modalRootRef = useRef(document.createElement("div"));

  useEffect(() => {
    const modalRoot = modalRootRef.current;
    modalRoot.id = "connection-modal-root";
    document.body.appendChild(modalRoot);

    return () => {
      document.body.removeChild(modalRoot);
    };
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsConnected(true);
      setIsVisible(true);
    };

    const handleOffline = () => {
      setIsConnected(false);
      setIsVisible(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div className="fixed bottom-4 left-4 z-50 animate-fade-in">
      <div
        className={`rounded-lg px-4 py-3 shadow-lg w-[320px] ${
          isConnected
            ? "border border-green-600 text-green-600 bg-green-50"
            : "border border-red-600 text-red-600 bg-red-50"
        }`}
      >
        <p className="font-medium">
          {isConnected ? "Connection Restored" : "Lost Connection"}
        </p>
        <p className="text-sm mt-1">
          {isConnected
            ? "Internet connection restored"
            : "Please check your internet connection"}
        </p>
      </div>
    </div>,
    modalRootRef.current
  );
};

export default ConnectionStatusModal;
